import React from 'react';

import { useSiteLoadSettings } from '~/app/hooks/useSiteLoadSettings';
import { SettingsContext } from '~/shared/context/settings.context';

export const SettingsProvider = ({ children }) => {
  const { settings, navigation } = useSiteLoadSettings();
  return <SettingsContext.Provider value={{ settings, navigation }}>{children}</SettingsContext.Provider>;
};
